/**
 * Ryan O'Dowd
 * 2022-05-06
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';
import globals from '@utils/globals';

const getStyles = ({fonts, globalScale, colors, windowWidthRaw}) => {
  const twoRows = (Platform.OS !== 'web' || windowWidthRaw < 550) && (globalScale >= globals.fontScales.large);

  return {
    columnWrapper: { // @TODO: rename
      flexDirection: 'column',
      width: '100%',
    },
    title: {
      flex: 1,
      fontSize: globalScale * 16,
      fontFamily: fonts.secondaryBold,
      color: colors.white,
    },
    date: {
      display: 'flex',
      fontSize: globalScale * 12,
      color: colors.white,
      opacity: 0.85,
    },
    metadataWrapper: {
      display: 'flex',
      flexDirection: 'column',
    },
    metadataRow: {
      display: 'flex',
      width: '100%',
      flexDirection: twoRows ? 'column' : 'row',
      // @TODO: flexWrap: 'wrap', // @TODO: not working (not dynamic)
      justifyContent: 'space-around',
    },
    twoRingsWrapper: {
      flexGrow: 1,
      minWidth: twoRows ? '100%' : '50%',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    progressWrapper: {
      flex: 1,
      padding: 1,
      paddingTop: 12,
    },
    topRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    toggleIconWrapper: { // @TODO: combine with edit
      position: 'absolute',
      top: 0,
      left: 0,
      display: 'flex',
      flexShrink: 1,
      alignSelf: 'flex-start',
      justifySelf: 'flex-start',
      zIndex: 10,
    },
    editIconWrapper: {
      position: 'absolute',
      top: 2,
      right: 2,
      display: 'flex',
      flexShrink: 1,
      alignSelf: 'flex-start',
      justifySelf: 'flex-end',
    },
    editIcon: {
      fontSize: globalScale * 22,
      color: colors.accent,
      alignSelf: 'flex-end',
    },
  };
};

export default getStyles;
